import React, { useContext } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Card, CardContent, Box, Typography } from '@mui/material';
import 'chart.js/auto';
import './RevenueStatistics.css'
import { dashboardContext } from '../../Dashboard';

const RevenueGraph = () => {

    const { data, isLoading } = useContext(dashboardContext);

    // Fallback to ensure consistent 12-month structure
    const monthlyData = Array.from({ length: 12 }, (_, index) => {
        const monthObj = data?.monthlyPercentages?.find(m => m.month === index + 1);
        return monthObj ? Number(monthObj.total) || 0 : 0;
    });
    // Check if all values are 0 or data is empty
    const hasData = monthlyData.some(value => value > 0);

    const chartData = {
        labels: [
            "Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ],
        datasets: [
            {
                label: "Monthly Revenue",
                data: monthlyData,
                backgroundColor: [
                    "#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0",
                    "#9966FF", "#FF9F40", "#66BB6A", "#42A5F5",
                    "#D4E157", "#FF7043", "#7E57C2", "#26C6DA"
                ],
                borderColor: "#fff",
                borderWidth: 2,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: "60%",
        plugins: {
            legend: {
                position: "bottom",
                labels: {
                    color: "#444",
                    font: {
                        size: 13,
                    },
                },
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const value = context.raw;
                        return `AED  ${value?.toLocaleString() ?? 0}`;
                    },
                },
            },
        },
    };
    return (
        <div>
            {/* <Box display="flex" justifyContent="space-between" alignItems="center">
            </Box> */}

            <Box
                mt={3}
                display="flex"
                flexDirection={{ xs: 'column', sm: 'row' }}
                alignItems="center"
                justifyContent="center"
                gap={3}
            >
                <div
                    style={{
                        width: "100%",
                        maxWidth: "340px",
                        height: "auto",
                        margin: "auto",
                    }}
                >
                    <div style={{ position: "relative", width: "100%", paddingBottom: "100%" }}>
                        <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}>
                            {/* {!isLoading && <Doughnut data={chartData} options={chartOptions} />} */}
                            {!isLoading && hasData ? (
                                <Doughnut data={chartData} options={chartOptions} />
                            ) : (
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                    height="100%"
                                >
                                    <Typography variant="h6" color="textSecondary">
                                        No Data Available
                                    </Typography>
                                </Box>
                            )}
                        </div>
                    </div>
                </div>
            </Box>
        </div>
    );
};

export default RevenueGraph;
